module.exports = __webpack_public_path__ + "img/card_admin_office_200.f3209183.jpg";